import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Redo = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.82929 9.43363C3.66684 5.71404 8.26601 4.36366 10.9815 7.04001L12.3185 8.35771L12.3185 6.44795C12.3185 6.17181 12.5423 5.94795 12.8185 5.94795C13.0946 5.94795 13.3185 6.17181 13.3185 6.44795L13.3185 9.55253C13.3185 9.68514 13.2658 9.81232 13.172 9.90609C13.0783 9.99986 12.9511 10.0525 12.8185 10.0525L9.7139 10.0525C9.43776 10.0525 9.2139 9.82866 9.2139 9.55252C9.2139 9.27638 9.43776 9.05252 9.7139 9.05252L11.5989 9.05253L10.2796 7.75223C8.12284 5.62661 4.47006 6.69912 3.80486 9.65331C3.7442 9.9227 3.47663 10.0919 3.20724 10.0313C2.93784 9.9706 2.76863 9.70303 2.82929 9.43363Z"
        fill={color}
      />
    </svg>
  )
})

export default Redo
